import { endPoints } from "@fixed/endPoints"

export const prepareUrl = (endPoint, extraUrl = null, id) => {
    let url = `${process.env.REACT_APP_HOST_URI}${endPoints[endPoint]}`
    if (extraUrl) url += `/${extraUrl}`
    url += id ? `/${id}` : ''
    return url
}